import * as yup from 'yup';
const validation = {
  Register: yup.object({
    fullName: yup.string().required('Name is required.'),
    password: yup.string().required('Password is required'),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('password')], 'Passwords must match')
      .required('Confirm Password is required'),
    emailAddress: yup.string().required('Email address is required.'),
  }),
};

export default validation;
